export const desktopFontSizes = {
  mini: '0.9rem',
  small: '1rem',
  medium: '1.25rem',
  big: '1.6rem',
  huge: '2.5rem',
  enormous: '3.3rem',
};

export const mobileFontSizes = {
  mini: '0.75rem',
  small: '0.9rem',
  medium: '1rem',
  big: '1.1rem',
  huge: '1.7rem',
  enormous: '2rem',
};

export const lightColors = {
  accent: '#9055b5',
  grey: '#636363',
  background: "#FFFFFF",
  base: "#000000"
};

export const darkColors = {
  accent: '#FF0745',
  grey: '#636363',
  background: "#000000",
  base: "#FFFFFF"
};

export const theme = {
  desktopBreakpoint: 710,
  smallBreakpoint: 530,
};
